/* Custom Product Tabs – minimal vanilla JS, scoped, no dependencies */
(function () {
  'use strict';

  function initTabs(container) {
    var isBlock  = container.classList.contains('cpt-block');
    var buttons  = container.querySelectorAll(isBlock ? '.cpt-block__btn'   : '.custom-tabs__btn');
    var panels   = container.querySelectorAll(isBlock ? '.cpt-block__panel' : '.custom-tabs__panel');

    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('aria-controls');

        /* Dezactivează tot */
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });

        /* Activează tab-ul apăsat */
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        var panel = document.getElementById(targetId);
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  function init() {
    document.querySelectorAll('.custom-tabs, .cpt-block').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.custom-tabs, .cpt-block').forEach(initTabs);
  });
})();
